import { IEmployee } from '../../services';
import { DeclarationService } from '../../services/declarations.service';
import * as moment from "moment";

class TimesheetDetailsController {
    timesheet: any;
    openShift: any;

    constructor(private $state: ng.ui.IStateService,
                private DeclarationService: DeclarationService,
                private SweetAlert: any,
                private $stateParams: ng.ui.IStateParamsService) {
        'ngInject';       
    }

    public $onInit = () => {
        this.openShift = this.$stateParams['openShiftId'];

        this.timesheet.shifts.forEach(s => {
            if(s.declarations.length > 0) {
                s.declarationsApproved = true;
                s.declarations.forEach(d => {
                    if (d.status != 3) {
                        s.declarationsApproved = false;
                    } 
                });
            } else {
                s.declarationsApproved = false;
            }
        });
    }

    approve(shift) {
        shift.declarations.forEach(declaration => {
            
            if (!declaration.invoiceId && !declaration.sendToCootje) {
                if(!this.timesheet.employeeIsZZp || declaration.zzpInvoiceNumber.length > 0){
                    declaration.status = 3;
                    this.DeclarationService.put(declaration.id, declaration).then((result) => {
                        declaration = result;
                        shift.declarationsApproved = true;
                    });
                } 
            }
        });
    }

    reject(shift) {
        shift.declarations.forEach(declaration => {
            if (!declaration.invoiceId && !declaration.sendToCootje) {
                if(this.timesheet.employeeIsZZp && declaration.status > 0){
                    declaration.status = 2;

                    this.DeclarationService.put(declaration.id, declaration).then((result) => {
                        declaration = result;
                    });
                }
            }
        });
    }

    isSameDay(start, end) {
        if (moment(start).toDate().getDate() == moment(end).toDate().getDate()) {
            return true;
        } else {
            return false;
        }
    }

    getDeclarationHours(declaration) {
        if (declaration.registrationType == '2') {
            if (declaration.value != null && declaration.value !== undefined) {
                return Number(declaration.value).toFixed(2);
            }
            return '0.00';
        }
        if (declaration.duration != null && declaration.duration !== undefined) {
            return Number(declaration.duration).toFixed(2);
        }
        if (declaration.registrationType == '1' && declaration.dateTimeFrom && declaration.dateTimeTo) {
            const hours = moment(declaration.dateTimeTo).diff(moment(declaration.dateTimeFrom), 'minutes') / 60;
            return hours.toFixed(2);
        }
        return '0.00';
    }

    getDeclarationTypeLabel(declaration, shift) {
        if (declaration.registrationType == '2') {
            return declaration.hourCodeName || declaration.wageCodeName || 'Onkosten';
        }
        if (shift && shift.isSleepShift) {
            if (declaration.isSleepShiftActiveWork === true) {
                return 'Gewerkt (met ORT)';
            }
            return 'Slaapdienst (geen ORT)';
        }
        return 'Gewerkte uren';
    }

    getDeclarationTypeClass(declaration, shift) {
        if (declaration.registrationType == '2') {
            return 'label-default';
        }
        if (shift && shift.isSleepShift) {
            if (declaration.isSleepShiftActiveWork === true) {
                return 'label-warning';
            }
            return 'label-sleep';
        }
        return 'label-primary';
    }

    deleteDeclaration(event, declaration, shift) {
        event.stopPropagation();

        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze declaration wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d96557',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.DeclarationService.item = declaration;
                this.DeclarationService.delete(declaration.id).then(() => {
                    shift.declarations = shift.declarations.filter(d => d.id !== declaration.id);
                });
            } else {

            }
        });
    }

    isInvoiced(shift) {
        for(var i=0; i<shift.declarations.length; i++ ){
            if(shift.declarations[i].invoiceId || shift.declarations[i].sendToCootje) {
                return true;
            }
        }
        return false;
    }

    isZZPOpen(shift) {
        for(var i=0; i<shift.declarations.length; i++ ){
           
            if(this.timesheet.employeeIsZZp && (shift.declarations[i].status == 0 && shift.declarations[i].zzpInvoiceNumber.length == 0)){
                return true;
            }
        }
        return false;
    }
}

export const timesheetDetailsComponent = {
    bindings: {
        timesheet: '<',
        calendarStartDate: '<',
        calendarEndDate: '<'
    },
    controller: TimesheetDetailsController,
    template: require('./timesheetDetails.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/timesheets/timesheetDetails.component.ts